import React from "react";

import { EmptyState, Skeleton } from "shared/ui";

import { ClientsTable } from "features/Clients/components/ClientsTable";
import { useClientsState } from "features/Clients/hooks/useClientsState";

import { Container, Message } from "./styles";

const ClientsScreen = () => {
    const state = useClientsState();

    const renderBody = () => {
        if (state.error) return <Message>Не удалось загрузить клиентов</Message>;

        if (state.clients.length === 0) {
            if (state.loading) return <Skeleton height="360px" />;

            return (
                <EmptyState
                    title="Клиентов пока нет"
                    description="Сюда попадают гости, оформившие заказ в вашем заведении."
                />
            );
        }

        return (
            <ClientsTable
                clients={state.clients}
                total={state.total}
                page={state.page}
                pageSize={state.pageSize}
                onPageChange={state.setPage}
            />
        );
    };

    return <Container>{renderBody()}</Container>;
};

export const Clients = ClientsScreen;
